import React from "react";
import { ChartsSetWrapperNew } from "../../../../../components";
import { chartAdvDataNew } from "./data";

const ColumnListAdv = () => {
  console.log(chartAdvDataNew);

  return (
    <div>
      <ChartsSetWrapperNew
        title="Column Chart"
        type="column"
        data={chartAdvDataNew.series}
        categories={chartAdvDataNew.categories}
        options={{
          column: {
            stacked: true,
          },
        }}
      />
    </div>
  );
};

export default ColumnListAdv;
